import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
 #SEGMENTED-CONTROL-ITEM
\*------------------------------------ */
/** 
 * 1) 
 */
.cat-c-segmented-control-item {
  position: relative;
}

.cat-is-active {
  background: var(--cat-theme-color-button-background);
}

:is(.cat-c-segmented-control-item__button, .cat-c-segmented-control-item__loader-wrapper) {
  appearance: none;
  border: 1px solid var(--cat-theme-color-border-default);
  background: var(--cat-theme-color-background-subtle);
  text-decoration: none;
  justify-content: center;
  border-start-start-radius: var(--cat-segmented-control-item-button-border-start-start-radius);
  border-start-end-radius: var(--cat-segmented-control-item-button-border-start-end-radius);
  border-end-start-radius: var(--cat-segmented-control-item-button-border-end-start-radius);
  border-end-end-radius: var(--cat-segmented-control-item-button-border-end-end-radius);
  border-inline-end: var(--cat-segmented-control-item-button-border-inline-end, none);
  border-inline-start: var(--cat-segmented-control-item-button-border-inline-start, none);
  align-items: center;
  padding: var(--cat-space-3x-small) var(--cat-space-medium);
  display: flex;
  height: 100%;
}
.cat-is-active :is(.cat-c-segmented-control-item__button, .cat-c-segmented-control-item__loader-wrapper):before {
  content: "";
  position: absolute;
  inset-block: 0;
  inset-inline: 0;
  border: 1px solid var(--cat-theme-color-border-strong);
  border-radius: calc(var(--size-base-unit) * 0.5);
}

.cat-c-segmented-control-item__button {
  cursor: pointer;
  padding: var(--cat-space-3x-small);
}
.cat-is-active:not(.cat-is-loading) .cat-c-segmented-control-item__button {
  background: transparent;
}
.cat-is-disabled .cat-c-segmented-control-item__button {
  cursor: not-allowed;
}
.cat-c-segmented-control-item__button:focus {
  outline: none;
}

.cat-c-segmented-control-item__wrapper {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  display: flex;
  color: var(--cat-theme-color-content-default);
  align-items: center;
  padding-inline: var(--cat-space-small);
  border-radius: calc(var(--size-base-unit) * 0.5);
}
.cat-is-active:not(.cat-is-loading) .cat-c-segmented-control-item__wrapper {
  color: var(--cat-theme-color-content-strong);
  font-weight: var(--cat-font-weight-semibold);
}
.cat-is-disabled .cat-c-segmented-control-item__wrapper {
  color: var(--cat-theme-color-content-disabled);
}
.cat-is-iconOnly .cat-c-segmented-control-item__wrapper {
  padding: var(--cat-space-3x-small);
}
.cat-c-segmented-control-item__wrapper:is(:hover, :active) {
  background-color: var(--cat-theme-color-button-background);
}
.cat-c-segmented-control-item__wrapper:is(:hover, :active) {
  background-color: var(--cat-theme-color-button-background);
}
.cat-is-disabled .cat-c-segmented-control-item__wrapper:is(:hover, :active) {
  background-color: var(--cat-theme-color-background-subtle);
}
.cat-c-segmented-control-item__wrapper:active {
  background-color: var(--cat-theme-color-button-background-active);
}
.cat-c-segmented-control-item__button:focus-visible .cat-c-segmented-control-item__wrapper {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-inset-focus-ring, -4px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  outline-offset: 0;
}

.cat-c-segmented-control-item:not(.cat-c-segmented-control-item--has-before) .cat-c-segmented-before-slot, .cat-c-segmented-control-item:not(.cat-c-segmented-control-item--has-after) .cat-c-segmented-after-slot {
  display: none;
}
`;
       